import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { retrievePublicStudios } from "@academy-context/read/application/use-cases/shared/studios-retrieval/retrieve-public-studios";
import { selectPublicStudiosRetrieval } from "@academy-context/read/application/use-cases/shared/studios-retrieval/selectors/public-studios-selectors";
import { onboardTeacher } from "@user-management-context/write/application/use-cases/teacher-onboarding/onboard-teacher";
import { selectTeacherOnboarding } from "@user-management-context/write/application/use-cases/teacher-onboarding/selectors/teacher-onboarding-selectors";
import type { OnboardTeacherBody } from "@shared-kernel/application/ports/shared/shared-repository";
import { TeacherOnboarding } from "./teacher-onboarding.content";
import { useTeacherOnboarding } from "./use-teacher-onboarding";

export const TeacherOnboardingContainer = () => {
  const dispatch = useAppDispatch();
  const { processing } = useAppSelector(selectTeacherOnboarding);
  const { data: publicStudios } = useAppSelector(selectPublicStudiosRetrieval);

  useEffect(() => {
    dispatch(retrievePublicStudios());
  }, [dispatch]);

  useTeacherOnboarding();

  const handleSubmit = (body: OnboardTeacherBody) => {
    dispatch(onboardTeacher(body));
  };

  return <TeacherOnboarding publicStudios={publicStudios ?? []} onSubmit={handleSubmit} submitting={processing === "pending"} />;
};
